// Copyright (c) 2020, Picsa Advisory Services (Pty) Ltd. All rights reserved.

import React from 'react'

import {
  SvgIcon
} from '../'


export const NoAccounts = () => (
  <div>
    <SvgIcon
      variant='utility'
      symbol='info'
      size='small'
      colour='light'
      className='slds-p-right_small'
    />
    No accounts to display.
  </div>
)



// WEBPACK FOOTER //
// ./src/components/identity-bankaccounts/NoAccounts.js